export default "__VITE_ASSET__CTai6jLF__"